import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { QuestionProcessingService } from '../services/question-processing.service';
import { TouchEventService } from '../services/touch-event.service';
import { timer } from 'rxjs/observable/timer';
import { BaseComponent } from '../Models/BaseComponent';
import { DennysFlow } from '../Models/dennysFlow';
import { DisplayLanguage } from '../Models/DisplayLanguage';
import { IntegrationService } from '../services/integration.service';
import { DynamicQuestionService } from '../services/dynamic-question.service';
import { Screening } from '../Models/Screening';
import { EmployeeLookup } from '../Models/EmployeeLookup';


@Component({
  selector: 'app-disclaimer',
  templateUrl: './disclaimer.component.html',
  styleUrls: ['./disclaimer.component.css']
})
export class DisclaimerComponent extends BaseComponent implements OnInit {

  @ViewChild('redirectForm') redirectForm:ElementRef;
  @ViewChild('isTaxCreditInput') isTaxCreditInput:ElementRef;
  @ViewChild('isCreditInput') isCreditInput:ElementRef;
  @ViewChild('taxBreakGuidInput') taxBreakGuidInput:ElementRef;
  @ViewChild('optedOutInput') optedOutInput:ElementRef;
  @ViewChild('returnCodeInput') returnCodeInput:ElementRef;

  languageLabel : string = 'ES';
  optedOut : boolean = false;
  loading : boolean = false;

  constructor(public location : Router, 
                private question : QuestionProcessingService, 
                public dynamicQuestion: DynamicQuestionService,
                public swiper : TouchEventService, 
                public route : ActivatedRoute,
                public integration : IntegrationService) {
    super(swiper,location);
    this.questions = question;
    if(this.route.snapshot.paramMap.get('applicantId') != null) {
      console.log(this.route.snapshot.paramMap.get('applicantId'));
      this.loading=true;
      this.integration.fetchPayload(this.route.snapshot.paramMap.get('applicantId')).subscribe((data) => {
        this.loading=false;
        this.integration.payload = data;
        console.log('payload', this.integration.payload);
      })
    }
    if(this.route.snapshot.paramMap.get('profileId') != null) {
      console.log(this.route.snapshot.paramMap.get('profileId'));
      this.loading=true;
      this.integration.fetchintegrationProfile(this.route.snapshot.paramMap.get('profileId')).subscribe((data) => {
        this.loading=false;
        this.integration.integrationProfile = data;
        console.log('payload', this.integration.integrationProfile);
      })
    }
    this.swiper.publisher.subscribe((args: any) => {
      console.log('swiping in direction : ', args);
      if(args == 'next')this.continue();
    })

    if(!dynamicQuestion.screening) {
      dynamicQuestion.screening = new Screening();
      dynamicQuestion.screening.demographics = new EmployeeLookup();
    }

    this.questions.dennys = new DennysFlow();
  }

  ngOnInit() {
    window.history.pushState(window.location.href, '', window.location.origin);
    document.getElementsByClassName('container')[0].classList.remove('slide-backward');
    document.getElementsByClassName('container')[0].classList.add('slide-forward');
    var tim = timer(0);
    tim.subscribe(t => {
      document.getElementsByClassName('container')[0].classList.remove('slide-forward');
    })
  }

  optout() : void {
    this.optedOut = !this.optedOut;
    if (this.integration.integrationProfile.returnUrl!=null)
    {
      this.isTaxCreditInput.nativeElement.value=false;
      this.isCreditInput.nativeElement.value=false;
      this.taxBreakGuidInput.nativeElement.value=this.integration.integrationProfile.taxBreakGUID;
      this.optedOutInput.nativeElement.value=true;
      this.returnCodeInput.nativeElement.value="";
      this.redirectForm.nativeElement.action=this.integration.integrationProfile.returnUrl;
      this.redirectForm.nativeElement.submit();
    }
  }

  continue() : void {
    this.location.navigateByUrl('/lookup');
  }

  toggleLanguage(lang? : DisplayLanguage) {
    //temporary solution until I have another language to mess around with OR
    //RADIAL MENUS!!!!!! 
    console.log(this.question.language);
    if(this.question.language == 0) {
      this.question.language = 1;
      this.languageLabel = 'EN';
      return;
    }
    if(this.question.language == 1) {
     this.question.language = 0;
     this.languageLabel = 'ES';
     return;
    }  
    
  }

  help() : void {
    console.log("Sample Tooltip!");
  }

}



// WEBPACK FOOTER //
// C:/git/SynergiPartners 7-Eleven Screening/src/app/disclaimer/disclaimer.component.ts